import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Hero from "./Hero";
import StatsSection from "./StatsSection";
import CheckoutOffers from "./CheckoutOffers";
import HomeProperties from "./HomeProperties/HomeProperties";
import BannerCarousel from "./BannerCarousel/BannerCarousel";

import PageFooter from "../common/PageFooter";
import MobileAppAds from "../common/MobileAppAds";
import MobileMenu from "../common/header/MobileMenu";
import DefaultHeader from "../common/header/DefaultHeader";
import HubzuSarchVariety from "../common/HubzuSearchVariety";

import { homeCmsData } from "@/redux/cms/cmsSelectors";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import CyberMondayBanner from "@/components/common/cyber-monday-banner/CyberMondayBanner";

import { processVisitor } from "@/api/home";
import { checkLoginStatus } from "@/api/myProfile";

import { encrypt } from "@/utils/crypto";
import { trackPageMount } from "@/utils/analytics";
import {
  generateHomePageSchema,
  injectSchema,
  removeSchema,
} from "@/utils/schema";

import "./home.css";

const Index = () => {
  const cmsData = useSelector(homeCmsData);

  const { width } = useWindowDimensions();

  const [isBannerVisible, setIsBannerVisible] = useState(false);

  // Inject schema for SEO
  const homeSchema = cmsData ? generateHomePageSchema(cmsData) : null;

  useEffect(() => {
    if (homeSchema) {
      injectSchema(homeSchema, "home-schema");
    }
    return () => removeSchema("home-schema");
  }, [cmsData]);

  useEffect(() => {
    let isMounted = true;

    const initializeData = async () => {
      try {
        const loginResponse = await checkLoginStatus();

        if (!isMounted) return;

        if (width < 991) {
          trackPageMount({
            pageName: "mobile_home",
            eventSource: "Page Load Attempt",
            eventCategory: "New-Homepage",
          });
        }

        if (!loginResponse?.isLoggedOut) {
          // User is logged in
          const userEmailId = loginResponse?.userEmailId;

          const redisPayload = new FormData();
          if (userEmailId) {
            const encryptedEmail = await encrypt(userEmailId);
            if (!isMounted) return;
            redisPayload.append("emailAddr", encryptedEmail);
          }

          await Promise.all([processVisitor()]);
        }

        // Track successful page mount regardless of login status
        if (isMounted) {
          trackPageMount({
            pageName: "home_page_2_0",
            eventCategory: "New-Homepage",
            eventSource: "Page Load Success",
          });
        }
      } catch (error) {
        console.error("Error initializing data:", error);
        if (isMounted) {
          trackPageMount({
            pageName: "home_page_2_0",
            eventCategory: "Error",
            eventSource: `Error - ${
              error.message || "Data Initialization Failed"
            }`,
          });
        }
      }
    };

    initializeData();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [width]);

  return (
    <>
      {/* <TakeTour page="home" /> */}
      {/* <!-- Main Header Nav --> */}
      {cmsData &&
        cmsData.cyberMondaybanner &&
        cmsData.cyberMondaybanner.showBanner && (
          <CyberMondayBanner
            campaignStartDate={cmsData.cyberMondaybanner.campaignStartDate}
            campaignChangeDate={cmsData.cyberMondaybanner.campaignChangeDate}
            campaignEndDate={cmsData.cyberMondaybanner.campaignEndDate}
            startMessage={cmsData.cyberMondaybanner.startMessage}
            endMessage={cmsData.cyberMondaybanner.endMessage}
            redirectUrl="/cybermonday"
            onVisibilityChange={setIsBannerVisible}
          />
        )}
      <DefaultHeader hasBanner={isBannerVisible} />

      {/* <!--  Mobile Menu --> */}
      <MobileMenu hasBanner={isBannerVisible} />

      {/* <!-- Modal --> */}
      {/* <PopupSignInUp /> */}

      {/* <!-- Home Design --> */}
      <main>
        <Hero data={cmsData} />

        {/* OutBid Section */}
        {/* {isUserLoggedIn && hasAlerts && (
          <section id="outbid" className="home-container pb-0">
            <div className="container">
              <Outbid setHasAlerts={setHasAlerts} />
            </div>
          </section>
        )} */}

        {/* <!-- Recommended Properties --> */}
        <section className="home-container pb30 pt50">
          <HomeProperties />
        </section>

        {/* <!-- Wide range of properties --> */}
        <section className="pt100 pb80 filter-card-bg">
          <div className="home-container">
            <HubzuSarchVariety data={cmsData} />
          </div>
        </section>

        {/* <!-- Banner Carousel --> */}
        <BannerCarousel />

        {/* <!-- Checkout Offers --> */}
        <section className=" pb30 pt50">
          <CheckoutOffers offerCmsData={cmsData?.checkoutOffers} />
        </section>

        {/* <!-- milestones --> */}

        <section className="pb90 filter-card-bg">
          <div className="home-container">
            <StatsSection cmsData={cmsData} />
          </div>
        </section>
        {/* <section className="milestone-section bg-ptrn2">
          <div className="container">
            <div className="discover-hubzu text-center">
              <h2>{cmsData?.hubzuDifference?.title} </h2>
            </div>
            <div className="row">
              <div className="col-sm-12 col-lg-12">
                <div className="row">
                  <div className="col-12 col-lg-3 mb-12 mb-lg-0">
                    <div className="mx-auto m-container">
                      <h3 className="mb-3 milestone-dh">
                        {cmsData?.hubzuDifference?.businessCount}
                      </h3>
                      <p className="fs-8 milestone-text-dh mb-0">
                        {cmsData?.hubzuDifference?.businessHeader}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3 mb-12 mb-lg-0">
                    <div className="mx-auto m-container">
                      <h3 className="mb-3 milestone-dh">
                        {cmsData?.hubzuDifference?.userCount}
                      </h3>
                      <p className="fs-8 milestone-text-dh mb-0">
                        {cmsData?.hubzuDifference?.userHeader}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="mx-auto m-container">
                      <h3 className="mb-3 milestone-dh">
                        {cmsData?.hubzuDifference?.propertySoldCount}
                      </h3>
                      <p className="fs-8 milestone-text-dh mb-0">
                        {cmsData?.hubzuDifference?.propertySoldHeader}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="mx-auto m-container">
                      <h3 className="mb-3 milestone-dh">
                        {cmsData?.hubzuDifference?.transactionsCount}
                      </h3>
                      <p className="fs-8 milestone-text-dh mb-0">
                        {cmsData?.hubzuDifference?.transactionsHeader}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* <!-- Register --> */}
        {/* {!isUserLoggedIn ? (
          <section className="start-partners pt50 pb50">
            <div className="container">
              <CallToAction />
            </div>
          </section>
        ) : (
          ""
        )} */}

        {/* <!-- Mobile App Ads --> */}
        <div className="home-container">
          <MobileAppAds cmsData={cmsData} />
        </div>
      </main>

      <div className="home-container"></div>

      <PageFooter />

      {/* <!-- Cyber Monday Banner --> */}
    </>
  );
};
export default Index;
